import { useEditor } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import type { Sponsor } from "src/types";

import PrimitivesFloatingOptions from "@/components/editor/block-outline/floating-options/primitives-floating-component";
import SyncedSponsorsSettings from "@/components/editor/shared/sponsors/sponsors-settings/synced-sponsors-settings-component";

import {
  StyledSponsorCard,
  StyledSponsorCardLogo,
  StyledSponsorCardText,
} from "./sponsor-card-component-styles";

export type SyncedSponsorCardProps = {
  sponsor: Sponsor;
};

export default function SyncedSponsorCard({ sponsor }: SyncedSponsorCardProps) {
  const { t } = useTranslation();

  const { isEnabled } = useEditor((state) => ({
    isEnabled: state.isEnabled(),
  }));

  return (
    <StyledSponsorCard
      target="_blank"
      rel="sponsored"
      aria-label={`${sponsor.name} ${t("common.website")} (${t(
        "common.opens-in-new-window"
      )})`}
      href={isEnabled ? null : sponsor.website}
    >
      <StyledSponsorCardLogo src={sponsor.image_url} alt="" draggable="false" />
      <StyledSponsorCardText>{sponsor.name}</StyledSponsorCardText>
    </StyledSponsorCard>
  );
}

SyncedSponsorCard.craft = {
  custom: {
    displayName: "Synced Sponsor Card",
  },
  related: {
    leftOutlineOptions: PrimitivesFloatingOptions,
    settings: SyncedSponsorsSettings,
  },
};
